import AxiosClient from '@services/api/base'
import routes from '@configs/api'

/**
 * Cart Summary
 * @param items
 * @param discounts
 * @param itemType
 * @param giftCardId
 * @param giftCardBalance
 * @param referralCode
 * @param promotionCode
 */

interface CartSummaryResponse {
  totalAmount: number
  totalDiscount: number
  amountToBePaidByGiftCard: number
  amountToBePaidByCreditCard: number
}

const getCartSummary = (
  items: string[],
  discounts: string[],
  itemType: string,
  giftCardId?: string | null,
  giftCardBalance?: number,
  referralCode?: string,
  promotionCode?: string,
  signal?: AbortSignal
): Promise<CartSummaryResponse> => {
  return new Promise((resolve, reject) => {
    const URL = routes.PAYMENTS + '/cart-summary'
    const config = {
      ...(signal && { signal }),
    }

    const data: any = {
      items,
      discounts,
      itemType,
      promotionCode,
      giftCardId,
    }
    if (giftCardBalance) {
      data.giftCardBalance = giftCardBalance
    }
    if (referralCode) {
      data.referralCode = referralCode
    }
    if (promotionCode) {
      data.promotionCode = promotionCode
    }
    AxiosClient.post(URL, data, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default getCartSummary

export type { CartSummaryResponse }
